module.exports = __webpack_public_path__ + "static/media/information-centre.bfb28653.svg";